import Sort from 'src/assets/images/SortAscending.svg';
import { Menu } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { BsArrowDownShort, BsArrowUpShort } from 'react-icons/bs';
import { FiChevronDown } from 'react-icons/fi';
import { HiSearch } from 'react-icons/hi';
import {
  PiCursor,
  PiForkKnifeLight,
  PiShoppingBag,
  PiTruckLight,
} from 'react-icons/pi';
import { useDispatch, useSelector } from 'react-redux';
import Order from 'src/components/order';
import { PaymentStatusButton } from 'src/components/payment-status';
import { NoTicket } from 'src/components/tickets';
import { CurrencyAmount } from 'src/containers/currency';
import { addCurrentOrder, addCurrentOrderInfo, addCurrentUser, clearCurrentOrder } from 'src/redux/action/currentOrder.action';
import { fetchSales } from 'src/redux/action/sales.action';
import { RootState } from 'src/redux/reducers';

const OpenTickets: React.FC = () => {
  const [selectedTicket, setSelectedTicket] = useState('');
  const [filteredText, setFilteredText] = useState('');
  const [filteredOrderType, setFilteredOrderType] = useState<string[]>([
    'dine_in',
    'takeaway',
    'delivery',
    'online_order',
  ]);
  const [filteredSortBy, setFilteredSortBy] = useState('createdUp');
  const [filterFloors, setFilterFloors] = useState('All');
  const { salesData, orderType } = useSelector(
    ({ salesData }: RootState) => salesData
  );
  const { users } = useSelector(
    ({ currentOrderData }: RootState) => currentOrderData
  );
  const { floors, orders } = salesData;

  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    dispatch(fetchSales() as any);
  }, []);

  // const filteredOrdersByOrderType = useMemo(() => {
  //   if (orders.length > 0) {
  //     const filteredOrders = orders.filter((order: any) =>
  //       filteredOrderType.includes(order.type)
  //     );
  //     return filteredOrders;
  //   } else {
  //     return [];
  //   }
  // }, [orders, filteredOrderType]);

  const filteredOrdersByOrderType = useMemo(() => {
    if (orders.length > 0) {
      const filteredOrders = orders.filter((order: any) => {
        if (order.origin === 'online') {
          order.type = 'online_order';
          return filteredOrderType.includes('online_order');
        } else {
          return filteredOrderType.includes(order.type);
        }
      });

      return filteredOrders;
    } else {
      return [];
    }
  }, [orders, filteredOrderType]);

  const filteredOrdersBySort = useMemo(() => {
    if (filteredOrdersByOrderType.length > 0) {
      if (filteredSortBy === 'createdUp') {
        return [...filteredOrdersByOrderType].sort((a, b) => {
          if (
            typeof a.createdAt === 'string' &&
            typeof b.createdAt === 'string'
          ) {
            return (
              new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
            );
          }
          return 0;
        });
      } else if (filteredSortBy === 'createdDown') {
        return [...filteredOrdersByOrderType].sort((a, b) => {
          if (
            typeof a.createdAt === 'string' &&
            typeof b.createdAt === 'string'
          ) {
            return (
              new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
            );
          }
          return 0;
        });
      } else if (filteredSortBy === 'amountUp') {
        // Sort by subTotal from highest to lowest
        return [...filteredOrdersByOrderType].sort((a, b) => {
          return b.subTotal - a.subTotal;
        });
      } else if (filteredSortBy === 'amountDown') {
        // Sort by subTotal from lowest to highest
        return [...filteredOrdersByOrderType].sort((a, b) => {
          return a.subTotal - b.subTotal;
        });
      } else {
        return filteredOrdersByOrderType;
      }
    } else {
      return [];
    }
  }, [filteredOrdersByOrderType, filteredSortBy]);

  const filteredOrdersByFloors = useMemo(() => {
    if (filteredOrdersBySort.length > 0) {
      if (filterFloors === 'All') {
        return filteredOrdersBySort;
      } else {
        return filteredOrdersBySort.filter(
          (order: any) => order?.table?.floorId === filterFloors
        );
      }
    } else {
      return [];
    }
  }, [filterFloors, filteredOrdersBySort]);

  const filteredTable = useMemo(() => {
    if (filteredOrdersByFloors.length > 0) {
      if (filteredText.trim().length > 0) {
        // const a = filteredOrdersByFloors.filter(
        //   (i: any) =>
        //     (i.table &&
        //       i?.table?.name
        //         .toLowerCase()
        //         .startsWith(filteredText.trim().toLowerCase())) ||
        //     i?.referenceNumber
        //       .toLowerCase()
        //       .startsWith(filteredText.trim().toLowerCase())
        // );
        const a = filteredOrdersByFloors.filter((i: any) =>
          i?.referenceNumber
            ?.split('-')[1]
            .startsWith(filteredText.toLowerCase())
        );
        return a;
      } else {
        return filteredOrdersByFloors;
      }
    } else {
      return [];
    }
  }, [filteredText, filteredOrdersByFloors]);

  const handleOrderTypeClick = (type: string) => {
    if (filteredOrderType.includes(type)) {
      const updatedFilter = filteredOrderType.filter((item) => item !== type);
      setFilteredOrderType(updatedFilter);
    } else {
      const updatedFilter = filteredOrderType.concat(type);
      setFilteredOrderType(updatedFilter);
    }
  };

  const handleSortByClick = (name: string) => {
    if (filteredSortBy === name) {
      setFilteredSortBy('');
    } else {
      setFilteredSortBy(name);
    }
  };

  const handleOrderClick = (id: string) => {
    if (selectedTicket === id) {
      setSelectedTicket('');
      return;
    } else {
      setSelectedTicket(id);
      dispatch(clearCurrentOrder());
      const dataOrders = orders.find((i: any) => i.id === id);
      const userInfo = JSON.parse(
        window.localStorage.getItem('userInfo') || ''
      );
      const user = dataOrders?.customer?.id
        ? users.find((userInfo) => userInfo.id === dataOrders.customer.id)
        : null;
      const a = {
        businessId: userInfo?.businessInfo?.id,
        type: dataOrders.type,
        tableId: dataOrders?.table?.id || null,
        tableName: dataOrders?.table?.name || null,
        userId: dataOrders?.customer?.id || null,
        origin: 'pos_device',
        promo: dataOrders?.promo || null,
        deliveryCharge:
          dataOrders?.type === 'delivery' ? dataOrders.deliveryCharge : 0,
        items:
          dataOrders.ordersItems.length > 0
            ? dataOrders.ordersItems.map((item: any) => {
                return {
                  id: item.id,
                  itemId: item.itemId,
                  name: item.itemName,
                  variantId: item.variantId,
                  hasVariants: item.hasVariants,
                  variantName: item.variantName,
                  identifierId: item.id,
                  quantity: item.quantity,
                  spiceLevel: item.spiceLevel || null,
                  selectedModifiers: item.allModifiers.map((modifier: any) => {
                    const optionsWithSelected = modifier.options.map(
                      (option: any) => {
                        const optionInModifiers = item.modifiers
                          .find((mod: any) => mod.id === modifier.id)
                          ?.options.find((op: any) => op.id === option.id);
                        return {
                          id: option.id,
                          price: option.price,
                          name: option.name,
                          hasSelected: !!optionInModifiers,
                        };
                      }
                    );
                    return {
                      id: modifier.id,
                      name: modifier.name,
                      options: optionsWithSelected,
                    };
                  }),
                  price: item.discountedPrice,
                  note: item?.note || '',
                };
              })
            : [],
      };

      if (dataOrders.ordersItems.length > 0) {
        dispatch(addCurrentOrder({ ...a }));
        if (user) {
          dispatch(
            addCurrentUser({
              id: user.id,
              name: user.name,
              email: user?.email || null,
              phone: parseFloat(user?.phone),
              image: user?.image || null,
            })
          );
        }
      }
      dispatch(addCurrentOrderInfo(dataOrders?.orderInfo));
    }
  };

  return (
    <>
      <div className="w-full h-[calc(100vh-75px)]   text-black flex flex-row justify-between gap-4  max-h-[100vh] ">
        <div className="w-full mb-5 h-full flex flex-col ">
          <div className="flex flex-row justify-end h-[41px] w-full">
            <div className=" flex flex-row gap-4 items-center">
              <div className="relative flex items-center w-[274px] h-[41px]">
                <input
                  type="text"
                  placeholder="Search open tickets"
                  className="pr-9 flex-1 w-full px-4 py-2 border border-[#CACFE3] rounded-full focus:outline-none "
                  onChange={(e) => {
                    setFilteredText(e.target.value);
                  }}
                />
                <div className="absolute right-3">
                  <HiSearch
                    className="text-gray-400"
                    style={{ fontSize: '20px' }}
                  />
                </div>
              </div>
              <button
                className="w-[32] h-[32] cursor-pointer"
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
              >
                <img src={Sort} alt="sort" />
              </button>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
                PaperProps={{
                  style: {
                    boxShadow: 'none',
                    border: '1px solid #F1F0F6',
                    width: '290px',
                    maxHeight: '290px',
                    height: 'fit',
                    backgroundColor: '#FFFFFF',
                    padding: '10px 16px',
                    marginTop: '10px',
                    overflow: 'hidden',
                  },
                }}
              >
                <div className="w-full flex flex-col gap-3 ">
                  <div className="flex flex-col">
                    <div className="font-Outfit font-normal mb-2 text-xs leading-[18px] text-[#7F8397]">
                      Order Type
                    </div>
                    <div className="flex flex-wrap gap-2 ">
                      {orderType?.dine_in && (
                        <div
                          className={`flex cursor-pointer h-[26px] w-[78px] items-center border justify-center rounded-[5px]  font-Outfit text-xs leading-[18px] ${
                            filteredOrderType.includes('dine_in')
                              ? ' border-[#4062FF] font-semibold text-[#4062FF]'
                              : 'border-[#CACFE3] font-normal text-[#7F8397] '
                          }`}
                          onClick={() => handleOrderTypeClick('dine_in')}
                        >
                          Dine In
                        </div>
                      )}
                      {orderType?.takeaway && (
                        <div
                          className={`flex  cursor-pointer h-[26px] w-[78px] items-center border justify-center rounded-[5px]  font-Outfit  text-xs leading-[18px] ${
                            filteredOrderType.includes('takeaway')
                              ? ' border-[#4062FF] font-semibold text-[#4062FF]'
                              : 'border-[#CACFE3] font-normal text-[#7F8397] '
                          } `}
                          onClick={() => handleOrderTypeClick('takeaway')}
                        >
                          Takeaway
                        </div>
                      )}
                      {orderType?.delivery && (
                        <div
                          className={`flex cursor-pointer h-[26px] w-[78px] items-center border justify-center rounded-[5px]  font-Outfit text-xs leading-[18px] ${
                            filteredOrderType.includes('delivery')
                              ? ' border-[#4062FF] font-semibold text-[#4062FF]'
                              : 'border-[#CACFE3] font-normal text-[#7F8397] '
                          }`}
                          onClick={() => handleOrderTypeClick('delivery')}
                        >
                          Delivery
                        </div>
                      )}

                      {orderType?.online_order && (
                        <div
                          className={`flex cursor-pointer h-[26px] w-[78px] items-center border justify-center rounded-[5px]  font-Outfit  text-xs leading-[18px]  ${
                            filteredOrderType.includes('online_order')
                              ? ' border-[#4062FF] font-semibold text-[#4062FF]'
                              : 'border-[#CACFE3] font-normal text-[#7F8397] '
                          } `}
                          onClick={() => handleOrderTypeClick('online_order')}
                        >
                          Online
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="flex flex-col">
                    <div className="font-Outfit font-normal mb-2 text-xs leading-[18px] text-[#7F8397]">
                      Sort by
                    </div>
                    <div className="flex flex-wrap gap-2 ">
                      <div
                        className={`flex cursor-pointer h-[26px] w-[78px] items-center border justify-center rounded-[5px]  font-Outfit  text-xs leading-[18px] ${
                          filteredSortBy === 'createdUp'
                            ? ' border-[#4062FF] font-semibold text-[#4062FF]'
                            : 'border-[#CACFE3] font-normal text-[#7F8397] '
                        }`}
                        onClick={() => handleSortByClick('createdUp')}
                      >
                        Created <BsArrowUpShort fontSize={18} />
                      </div>
                      <div
                        className={`flex  cursor-pointer h-[26px] w-[78px] items-center border justify-center rounded-[5px]  font-Outfit  text-xs leading-[18px] ${
                          filteredSortBy === 'createdDown'
                            ? ' border-[#4062FF] font-semibold text-[#4062FF]'
                            : 'border-[#CACFE3] font-normal text-[#7F8397] '
                        }`}
                        onClick={() => handleSortByClick('createdDown')}
                      >
                        Created <BsArrowDownShort fontSize={18} />
                      </div>
                      <div
                        className={`flex cursor-pointer h-[26px] w-[78px] items-center border justify-center rounded-[5px]  font-Outfit  text-xs leading-[18px] ${
                          filteredSortBy === 'amountUp'
                            ? ' border-[#4062FF] font-semibold text-[#4062FF]'
                            : 'border-[#CACFE3] font-normal text-[#7F8397] '
                        }`}
                        onClick={() => handleSortByClick('amountUp')}
                      >
                        Amount <BsArrowUpShort fontSize={18} />
                      </div>
                      <div
                        className={`flex cursor-pointer h-[26px] w-[78px] items-center border justify-center rounded-[5px]  font-Outfit  text-xs leading-[18px] ${
                          filteredSortBy === 'amountDown'
                            ? ' border-[#4062FF] font-semibold text-[#4062FF]'
                            : 'border-[#CACFE3] font-normal text-[#7F8397] '
                        } `}
                        onClick={() => handleSortByClick('amountDown')}
                      >
                        Amount <BsArrowDownShort fontSize={18} />
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col">
                    <div className="font-Outfit font-normal mb-2 text-xs leading-[18px] text-[#7F8397]">
                      Filter floors
                    </div>
                    <div className="relative">
                      <select
                        className="w-full h-[36px] rounded-xl border outline-none cursor-pointer border-[#CACFE3] appearance-none px-[20px] font-Outfit font-normal text-xs"
                        value={filterFloors}
                        onChange={(event) => {
                          setFilterFloors(event.target.value);
                        }}
                      >
                        <option value="All">All</option>
                        {floors.map((floor: any) => (
                          <option key={floor.id} value={floor.id}>
                            {floor.name}
                          </option>
                        ))}
                      </select>
                      <div className="absolute right-2 top-1/2 transform -translate-y-1/2">
                        <FiChevronDown className="text-gray-400" />
                      </div>
                    </div>
                  </div>
                </div>
              </Menu>
            </div>
          </div>
          <div className="mt-4 w-full flex flex-wrap gap-4  h-fit overflow-auto ">
            {filteredTable.length > 0 ? (
              <>
                {' '}
                {filteredTable.map((order: any) => {
                  let promoAmount = 0;
                  if (order?.promo) {
                    if (order.promo?.type === 'percent') {
                      promoAmount = (order.promo.value / 100) * order.subTotal
                    }
                    if (order.promo?.type === 'amount') {
                      promoAmount = order.promo.value;
                    }
                  }

                  let totalTaxAmount = 0;
                  if (order.taxes.length > 0) {
                    totalTaxAmount = order.taxes.reduce(
                      (acc: any, tax: any) => {
                        if (tax.type === 'percent') {
                          return acc + (tax.value / 100) * order.subTotal;
                        } else if (tax.type === 'amount') {
                          return acc + tax.value;
                        }
                        return acc;
                      },
                      0
                    );
                  }
                  return (
                    <div
                      key={order.id}
                      onClick={() => {
                        handleOrderClick(order.id);
                      }}
                      className={`w-[348px] p-4 rounded-xl border h-fit flex flex-col gap-[6px] cursor-pointer ${
                        order.id === selectedTicket
                          ? 'border-primary bg-[#4062FF] bg-opacity-20'
                          : ' border-[#F1F0F6]'
                      }`}
                    >
                      <div className="h-[22px] flex justify-between items-center w-full ">
                        <div className="flex gap-2">
                          {order.type === 'dine_in' && (
                            <div className="flex justify-center items-center w-[22px] h-[22px] rounded-[5px] border border-[#CACFE3]">
                              <PiForkKnifeLight color="#7F8397" />
                            </div>
                          )}
                          {order.type === 'takeaway' && (
                            <div className="flex justify-center items-center w-[22px] h-[22px] rounded-[5px] border border-[#CACFE3]">
                              <PiShoppingBag color="#7F8397" />
                            </div>
                          )}
                          {order.type === 'delivery' && (
                            <div className="flex justify-center items-center w-[22px] h-[22px] rounded-[5px] border border-[#CACFE3]">
                              <PiTruckLight color="#7F8397" />
                            </div>
                          )}
                          {order.type === 'online_order' && (
                            <div className="flex justify-center items-center w-[22px] h-[22px] rounded-[5px] border border-[#CACFE3]">
                              <PiCursor color="#7F8397" />
                            </div>
                          )}
                          <div
                            className={`w-fit px-2 uppercase  bg-opacity-20 h-[22px] flex items-center justify-center rounded-[5px]  font-Outfit font-normal text-[12px] leading-[18px] ${
                              order.status === 'preparing'
                                ? 'text-[#4062FF] bg-[#4062FF] border-none'
                                : order.status === 'dispatched'
                                ? 'text-[#FEC02D] bg-[#FEC02D] border-none'
                                : order.status === 'cooking'
                                ? 'text-success bg-success border-none'
                                : order.status === 'new'
                                ? 'text-[#7F8397] bg-[#7F839733]'
                                : order.status === 'failed' ||
                                  order.status === 'canceled'
                                ? 'text-[#E22B41] bg-[#E22B41] border-none'
                                : order.status === 'delivered'
                                ? 'text-[#0BC988] bg-[#0BC988] border-none'
                                : order.status === 'completed'
                                ? 'text-[#2B2B2B] bg-[#2B2B2B]'
                                : 'text-[#7F839733] bg-[#7F839733]'
                            }`}
                          >
                            {order.status}
                          </div>

                          {order.origin === 'online' && (
                            <div className="w-[49px] h-[22px] flex items-center justify-center rounded-[5px] border border-[#CACFE3] font-Outfit font-normal text-[#7F8397] text-[12px] leading-[18px]">
                              WEB
                            </div>
                          )}
                          {order.origin === 'pos_device' && (
                            <div className="w-[49px] h-[22px] flex items-center justify-center rounded-[5px] border border-[#CACFE3] font-Outfit font-normal text-[#7F8397] text-[12px] leading-[18px]">
                              POS
                            </div>
                          )}
                          {order.origin === 'customer_app' && (
                            <div className="w-[49px] h-[22px] flex items-center justify-center rounded-[5px] border border-[#CACFE3] font-Outfit font-normal text-[#7F8397] text-[12px] leading-[18px]">
                              APP
                            </div>
                          )}
                          {PaymentStatusButton(order.paymentStatus)}
                        </div>
                      </div>
                      <div className="w-full h-[24px] flex justify-between items-center ">
                        <div className="font-Outfit font-semibold text-[16px] leading-6 ">
                          {/* <>Takeaway- {order?.referenceNumber}</> */}
                          {order?.type === 'takeaway' && (
                            <>Takeaway- {order?.referenceNumber}</>
                          )}
                          {order?.type === 'delivery' ||
                            (order?.type === 'online_order' && (
                              <>Delivery- {order?.referenceNumber}</>
                            ))}
                          {order?.type === 'dine_in' && (
                            <>
                              Table- {order?.table?.name} (
                              {order.referenceNumber})
                            </>
                          )}
                        </div>
                      </div>
                      <div className="font-Outfit font-normal text-[16px] leading-6">
                        <CurrencyAmount
                          amount={parseFloat(
                            order.subTotal +
                              totalTaxAmount -
                              promoAmount +
                              order?.deliveryCharge || 0
                          ).toFixed(2)}
                        />
                      </div>
                      <div className="w-full h-[18px] flex justify-between items-center ">
                        <div className="font-Outfit font-normal text-[12px] leading-[18px] text-[#949CC0]">
                          by {order.employee ? order?.employee?.name : 'owner'}
                        </div>
                        <div className="font-Outfit font-normal text-[12px] leading-[18px] text-[#949CC0]">
                          {moment(order?.createdAt).fromNow()}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </>
            ) : (
              <div>No tickets found</div>
            )}
          </div>
        </div>
        {selectedTicket ? (
          <Order
            isEditing={false}
            orderId={selectedTicket}
            openTicket={true}
            payment={false}
            orderData={orders.find((i: any) => i.id === selectedTicket)}
          />
        ) : (
          <div className="fixed top-0 right-0 h-full">
            <NoTicket />
          </div>
        )}
      </div>
    </>
  );
};

export default OpenTickets;
